import { useEffect } from "react"
import { getRenewalStatus } from "./utils/renewalWindow";


const UseGetStepHookDucPage = (data: any, setActiveStep: Function, setExpired: Function,
    setExpiring: Function, setDeclined: Function, setCheckedCurrentStatus: Function) => {

    //This hook is to get the current step in the duc process to show on the stepper in the general and aian components
    useEffect(() => {
        if(data){
            setCheckedCurrentStatus(true)
            if(data?.status  === "NotSubmitted" || data?.status  === "Submitted"){
                setActiveStep(1);
            }
            if(data?.status  === "InProgress"){
                setActiveStep(2);
            }
            if(data?.status  === "InProgress" && typeof data?.dateSignedOfficial !== 'undefined'){
                setActiveStep(3);
            }
            if(data?.status === "Approved"){
                setActiveStep(4);
                const { expired, expiring } = getRenewalStatus({ status: data?.status, expiresOn: data?.expiresOn })
                setExpired(expired)
                setExpiring(expiring)
                setActiveStep(4);
            }
            if(data?.status  === "Declined"){
                setDeclined(true)
                if(data?.declinedBy === "Submitter"){
                    setActiveStep(1)
                }
                else if(data?.declinedBy === "Official"){
                    setActiveStep(2)
                }
                else if(data?.declinedBy === "Committee"){
                    setActiveStep(3)
                }
            }

            // 'DucExpired'/'TrainingExpired' are the statuses the backend actually emits (there is no 'Expired')
            if(data?.status === 'DucExpired' || data?.status === 'TrainingExpired'){
                setExpired(true)
            }
        }
    })

}

export default UseGetStepHookDucPage